<div class="w-full py-3 px-4">
  <!-- Add Ready Product Title Section -->
  <div class="md:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <!-- Back Button SVG (clickable) -->
      <svg class="size-6 cursor-pointer" [routerLink]="['/home']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">

        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
      </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/stock/ready-product.png" alt="user">
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">New Packaging Entry</span>
    </div>
  </div>
  <form [formGroup]="packagingForm">
    <div class="w-full flex justify-center">
      <div
        class="w-full max-w-[600px] px-3 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 2xl:grid-cols-10 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5 items-center">

        <div class="col-span-8">
          <div class="relative">
            <input type="text" id="st_item_name" formControlName="st_item_name" autocomplete="off"
              (keydown.enter)="focusNext($event)" class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal
             bg-white rounded-md border-1 border-dcdcdc appearance-none
             focus:outline-none focus:ring-0 focus:border-c19725 peer" placeholder=" " [class.border-red-500]="
        packagingForm.get('st_item_name')?.invalid &&
        packagingForm.get('st_item_name')?.touched
      " />

            <label for="st_item_name" class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform
             -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
             peer-focus:text-c19725
             peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2
             peer-placeholder-shown:top-1/2 peer-focus:top-2
             peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Name <span class="text-red-500">*</span>
            </label>
          </div>

          <!-- Validation Error (NO layout change) -->
          <div *ngIf="
      packagingForm.get('st_item_name')?.invalid &&
      packagingForm.get('st_item_name')?.touched
    " class="text-red-500 text-xs mt-1">
            *Name is required
          </div>
        </div>

      </div>
    </div>

    <div class="w-full py-4 bg-[#FFFFF6] rounded-md">
      <div
        class="w-full px-3 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 2xl:grid-cols-8 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5">

        <div class="col-span-1">
          <div class="relative">
            <select autocomplete="off" id="st_type" formControlName="st_type" (keydown.enter)="focusNext($event)" class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md
             border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0
             focus:border-c19725 peer" placeholder=" " [class.border-red-500]="
        packagingForm.get('st_type')?.invalid &&
        packagingForm.get('st_type')?.touched
      ">
              <option value="" selected disabled hidden>Major / Minor</option>
              <option value="minor">Minor</option>
              <option value="major">Major</option>
            </select>

            <label for="st_type" class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform
             -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
             peer-focus:px-1.5 peer-focus:text-c19725
             peer-placeholder-shown:scale-100
             peer-placeholder-shown:-translate-y-1/2
             peer-placeholder-shown:top-1/2
             peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4
             rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Major / Minor
            </label>
          </div>

          <!--  Validation Error-->
          <div *ngIf="
      packagingForm.get('st_type')?.invalid &&
      packagingForm.get('st_type')?.touched
    " class="text-red-500 text-xs mt-1">
            *Major / Minor is required
          </div>
        </div>


        <div class="col-span-1">
          <div class="relative max-w-sm">
            <input id="billDate" type="date" formControlName="st_packaging_date" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder="" />
            <label for="billDate"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Date
            </label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="st_unit_price" formControlName="st_unit_price" autocomplete="off"
              (keydown.enter)="focusNext($event)" class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal
             bg-white rounded-md border-1 border-dcdcdc appearance-none
             focus:outline-none focus:ring-0 focus:border-c19725 peer" placeholder=" " [class.border-red-500]="
        packagingForm.get('st_unit_price')?.invalid &&
        packagingForm.get('st_unit_price')?.touched
      " />

            <label for="st_unit_price" class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform
             -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
             peer-focus:px-1.5 peer-focus:text-c19725
             peer-placeholder-shown:scale-100
             peer-placeholder-shown:-translate-y-1/2
             peer-placeholder-shown:top-1/2
             peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4
             rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Cost Per Box <span class="text-red-500">*</span>
            </label>
          </div>

          <!--  Validation Error (NO layout change) -->
          <div *ngIf="
      packagingForm.get('st_unit_price')?.invalid &&
      packagingForm.get('st_unit_price')?.touched
    " class="text-red-500 text-xs mt-1">
            *Cost per box is required
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="st_quantity" formControlName="st_quantity" autocomplete="off"
              (keydown.enter)="focusNext($event)" class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal
             bg-white rounded-md border-1 border-dcdcdc appearance-none
             focus:outline-none focus:ring-0 focus:border-c19725 peer" placeholder=" " [class.border-red-500]="
        packagingForm.get('st_quantity')?.invalid &&
        packagingForm.get('st_quantity')?.touched
      " />

            <label for="st_quantity" class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform
             -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
             peer-focus:px-1.5 peer-focus:text-c19725
             peer-placeholder-shown:scale-100
             peer-placeholder-shown:-translate-y-1/2
             peer-placeholder-shown:top-1/2
             peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4
             rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Quantity <span class="text-red-500">*</span>
            </label>
          </div>

          <!-- Validation Error (NO layout change) -->
          <div *ngIf="
      packagingForm.get('st_quantity')?.invalid &&
      packagingForm.get('st_quantity')?.touched
    " class="text-red-500 text-xs mt-1">
            *Quantity is required
          </div>
        </div>

        <div class="col-span-2 sm:col-span-1">
          <div class="relative">
            <input type="number" id="st_final_valuation" formControlName="st_final_valuation" autocomplete="off"
              (keydown.enter)="focusNext($event)" readonly
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-[#F2F2F2] rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="st_final_valuation"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-[#F2F2F2] px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Final
              Value </label>
          </div>
        </div>

      </div>
    </div>

    <div class="flex items-center justify-center mt-4 md:mt-8 space-x-1.5 md:space-x-4">
      <button type="button" (click)="onClear()"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-c19725 bg-white border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
        Clear
      </button>

      <button type="button" *ngIf="submitbutton" (click)="onSubmit()"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
        Submit
      </button>

      <button type="button" *ngIf="updatebutton" (click)="editpackage()"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
        Update
      </button>
    </div>
  </form>
  <div class="w-full px-3 mb-4 lg:mb-0 mt-5">
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-start gap-1 lg:gap-2">
        <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Packaging List</span>
      </div>

      <a routerLink="/report/stock-packaging-list"
        routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
        class=" px-4 py-2 rounded-tl-[5px] rounded-[5px] border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
        View Report
      </a>
    </div>
    <div class="mt-4">
      <!-- Desktop Table -->
      <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
        <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
          <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs">
            <tr>
              <th class="p-2 font-medium text-center border-r border-[#0C447D]">No.</th>
              <th class="p-2 font-medium text-left border-r border-[#0C447D]">Item Name</th>
              <th class="p-2 font-medium text-left border-r border-[#0C447D]">Packaging Type</th>
              <th class="p-2 font-medium text-left border-r border-[#0C447D]">Suplier Name</th>
              <th class="p-2 font-medium text-left border-r border-[#0C447D]">Cost Per Box</th>
              <th class="p-2 font-medium text-left border-r border-[#0C447D]">Quantity</th>
              <th class="p-2 font-medium text-left border-r border-[#0C447D]">Final Valuation</th>
              <th class="p-2 font-medium text-center border-r border-[#0C447D]">Date</th>
              <th class="p-2 font-medium text-center border-r border-[#0C447D]">Action</th>
            </tr>
          </thead>
          <tbody class="text-xs sm:text-xs">
            <tr class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]"
              *ngFor="let packaging of packagingDataList; let i = index">
              <td class="p-3 text-center">{{ i + 1 }}</td>
              <td class="p-3 font-medium">{{ packaging.st_item_name }}</td>
              <td class="p-3 font-medium text-c19725">{{ packaging.st_type }}</td>
              <td class="p-3">{{ packaging.st_supplier_name }}</td>
              <td class="p-3">{{ packaging.st_unit_price }}</td>
              <td class="p-3">{{ packaging.st_quantity }}</td>
              <td class="p-3">{{ packaging.st_final_valuation }}</td>
              <td class="p-3 text-center">{{ packaging.st_packaging_date | date: 'dd-MM-yyyy' }}</td>
              <td>
                <div class="flex items-center justify-center gap-1 sm:gap-2">

                  <button class="cursor-pointer" [routerLink]="['/packaging-form', packaging.st_id,]">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                        stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>

                  <button class="cursor-pointer p-1" (click)="deletePackaging(packaging.st_id)">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 25" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                        stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                        stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>